module.exports = function inquire() { return null; };
